// extracted by mini-css-extract-plugin
export default {"faq_card":"styles_faq_card__rysCL","accordion":"styles_accordion__wEcCp"};